import { authHeader } from "./auth-header";
import axiosClient from "../../api/axios.config";
import { getTokenData } from "./tokenUtils.js";

export const userService = {
  usuarioLogueado,
  login,
  logout,
  register,
  checkInstance,
  getAll,
  refreshToken,
  testRefreshToken
};

async function usuarioLogueado(){
  try {
      const response = await axiosClient({
          method: "get",
          url: "/recepcionador_backend/v1/profile/me",
      })

      if(response.data.success){
          return {success: true, data: response.data}
      }else{
          return {success: false, data: response.data.error}
      }
  } catch (error) {
      console.log('error');
      console.log(error.response);
  }
}

async function testRefreshToken(payload){
  try {
      const response = await axiosClient({
          method: "get",
          url: "v3/descargas/info-emisor",
          params: payload
      })

      if(response.data.success){
          return {success: true, data: response.data}
      }else{
          return {success: false, data: response.data.error}
      }
  } catch (error) {
      console.log(error);        
  }
}

async function login(payload) {
  try {

    const { email, password, rfc } = payload;
    const body = {
      mail: email,
      pass: password,
      rfc: rfc,
    };

    const response = await axiosClient({
      method: "post",
      url: "v1/reception/acceso/login",
      data: body,
    });
    
    if (response.data.success == true) {
      const dataDecoded = getTokenData(response.data.data.access_token);
      const user = {
        userName: dataDecoded.userName,
        instance: dataDecoded.instance,
      };

      sessionStorage.setItem("user", JSON.stringify(user));
      sessionStorage.setItem("idToken", response.data.data.access_token);
      sessionStorage.setItem("refreshToken", response.data.data.refresh_token);

      return { success: true, data: response.data, user: user };
    } else {
      return { success: false, data: response.message};
    }
  } catch (error) {
    console.log('error login');
    console.log(error.response.data.message);
    return { success: false, data: error.response.data.message,  user: null};
  }
}

async function refreshToken(payload) {

  try {
    const response = await axiosClient({
      method: "post",
      url: "v1/reception/acceso/jwt/refresh",
      data: payload,
    });
  
    if (response.data) {
      return response;
    } else {
      return response;
    }  
  } catch (error) {
    console.log('error refresh');
    console.log(error.response);
  }
} 

function logout() {
  // remove user from local storage to log user out
  sessionStorage.removeItem("user");
}

async function register(user) {
  const body = {
    userrfc: user.rfc,
    username: user.email,
    userpass: user.password,
    phone: user.phone,
    isexistingcustomerincrm: user.isexistingcustomerincrm,
    razonsocial: user.razonSocial,
    certificado: user.certificadoToSend
  };
  const response = await axiosClient({
    method: "post",
    url: "v1/acceso/registro",
    data: body,
  });
  return response.data;
}

async function checkInstance(payload) {
  const { userrfc } = payload;
  const response = await axiosClient.post("/v1/acceso/verificarInstancia", {
    userrfc,
  });
  return response.data;
}

function getAll() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`/users`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        logout();
        location.reload(true);
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}
 